module.exports = __webpack_public_path__ + "img/cd.9ddca77f.svg";